import { L as Linkify } from "../chunks/Linkify-BtgR-dXX.mjs";
const directive = function(el, binding) {
  var _a;
  if (((_a = binding.value) == null ? void 0 : _a.linkify) === true) {
    el.innerHTML = Linkify(binding.value.text);
  }
};
export {
  directive as default,
  directive
};
